export default class OnboardingModalHelper {
  constructor(modalController) {
    this.modalController = modalController
    this.handleModalHide = this.handleModalHide.bind(this)
  }

  connect() {
    this.modalController.isOnboardingModal = true
    this.modalController.element.addEventListener(
      'hide.bs.modal',
      this.handleModalHide
    )
  }

  disconnect() {
    this.modalController.isOnboardingModal = false
    this.modalController.element.removeEventListener(
      'hide.bs.modal',
      this.handleModalHide
    )
  }

  handleModalHide(event) {
    if (this.modalController.allowModalClose) {
      this.modalController.allowModalClose = false
      return
    }

    const form = this.modalController.element.querySelector(".sign-up-form");
    if (form && !this.hasFormValues()) return;

    event.preventDefault()
    this.showConfirmation()
  }

  hasFormValues() {
    const form = this.modalController.element.querySelector(".sign-up-form");
    if (!form) return false;

    const fields = form.querySelectorAll(
      'input:not([type="hidden"]), select'
    );

    return [...fields].some((field) => {
      if (field.disabled || field.type === "submit" || field.type === "button") {
        return false;
      }

      if (field.closest(".d-none")) return false;

      if (field.type === "checkbox") {
        return field.checked;
      }

      return field.value.trim() !== "";
    });
  }

  showConfirmation() {
    Swal.fire({
      customClass: {
        popup:
          'swal-popup alert-sm-bg align-items-center justify-content-center w-100',
        htmlContainer: 'text-black-paint text-white'
      },
      title: 'Confirmation',
      text: 'Are you sure you want to close this modal? Your onboarding process isn’t complete yet.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'Keep Editing'
    }).then((result) => {
      if (result.isConfirmed) {
        this.modalController.allowModalClose = true
        this.modalController.closeModal()
      }
    })
  }
}